import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';

import Switch from '@material-ui/core/Switch';

import Tree from '../../../tree/Index';

// eslint-disable-next-line
import style from './_style.css';

function formatTree(node) {
    return {
        id: parseInt(node.id, 10),
        nombre: node.name,
        hijos: node.children.map((c) => formatTree(c)),
    };
}

class Employee extends React.Component {

    renderNode = (node) => {
        const { info, locales } = this.props;
        const add =
            node &&
                node.id &&
                info &&
                info.security &&
                info.security.localPermits &&
                info.security.localPermits[node.id.toString()]
                ? info.security.localPermits[node.id.toString()].some(
                    (r) => r === '20' || r === '84',
                )
                : info && info.security && info.security.globalPermits
                    ? info.security.globalPermits.some((r) => r === '20' || r === '84')
                    : undefined;

        const active = locales && locales.filter((f) => f.id === node.id).length > 0;

        return (
            <div
                className="flex_full_row "
                onMouseDown={function (e) {
                    e.stopPropagation();
                }}
            >
                <span
                    className={
                        'barlow_regular_small flex_full_row padding_4 align_center'
                    }
                    onMouseDown={function (e) {
                        e.stopPropagation();
                    }}
                >
                    {node.name}
                </span>
                {(node.children && node.children.length === 0) &&
                    <Switch
                        name={node.name}
                        disabled={!add}
                        checked={active}
                        onChange={() => this.props.onChange(node.id, node.name)}
                        value="active"
                        color="primary"
                    />
                }
            </div>
        );
    };

    renderCollapse = (collapsed) => {
        return (
            <span
                className={cx(
                    'collapse padding_top_12 c_white ',
                    collapsed ? 'caret-right' : 'caret-down',
                )}
                onMouseDown={function (e) {
                    e.stopPropagation();
                }}
                onClick={this.handleCollapse}
            />
        );
    };


    processRecursiveLocasl = (nodes) => {
        return nodes.map((n) => {
            return {
                id: n.id,
                name: n.nombre,
                children:
                    n.hijos && n.hijos.length > 0
                        ? this.processRecursiveLocasl(n.hijos)
                        : [],
            };
        });
    };

    processTreeLocals = (intl, locals) => {
        const childs = this.processRecursiveLocasl(locals);

        if(childs.length > 1) {
            return {
                id: null,
                name: intl.formatMessage({ id: 'global' }),
                children: childs
            };
        } else {
            return childs[0];
        }
    };

    render() {
        const { intl, info } = this.props;

        const tree = info && info.security
                        ? this.processTreeLocals(intl, [formatTree(info.security.hierarchies)])
                        : undefined;

        if (tree) {
            return (
                <div className="flex_full_column">
                    <div className="flex_auto_row margin_bottom_24">
                        <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                            <FormattedMessage id="manage_local_menu" />
                        </div>
                    </div>
                    <div className={'flex_full_row rol-tree'}>
                        {tree && (
                            <Tree
                                paddingLeft={40} // left padding for children nodes in pixels
                                tree={tree}
                                renderNode={this.renderNode} // renderNode(node) return react element
                                renderCollapse={this.renderCollapse}
                                isNodeCollapsed={this.isNodeCollapsed}
                            />
                        )}
                    </div>
                </div>
            )
        } else {
            return <div />;
        }


    }
}

Employee.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
    };
};

Employee = connect(
    mapStateToProps,
    null,
)(Employee);

Employee = injectIntl(Employee);

export default Employee;



// WEBPACK FOOTER //
// ./src/components/complex/manage/employee/Tree.js